<ul>
  <ng-container *ngFor="let item of items; let i = index">
    <li class="suggest-head" *ngIf="i === 0 || items[i - 1].kind !== item.kind">
      <span>{{ ('HEADER.SUGGEST_' + item.kind.toUpperCase()) | translate }}</span>
      <a *ngIf="item.kind === 'recent'" class="suggest-clear" (click)="onClear($event)">{{ 'HEADER.SUGGEST_CLEAR' | translate }}</a>
    </li>
    <li class="suggest-item suggest-{{item.kind}}" [class.active]="i === activeIndex"
      (click)="select.emit(item)" (mouseenter)="activate.emit(i)">
      <span *ngIf="item.kind === 'video'" class="suggest-thumb"
        [style.background-image]="'url(' + (item.video?.thumbnail_image || defaultThumb) + ')'"></span>
      <svg *ngIf="item.kind === 'recent'" class="suggest-ic" viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M13 3a9 9 0 0 0-9 9H1l3.9 3.9L8.8 12H6a7 7 0 1 1 7 7 6.96 6.96 0 0 1-4.95-2.05l-1.42 1.42A8.96 8.96 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"/></svg>
      <svg *ngIf="item.kind === 'popular'" class="suggest-ic" viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/></svg>
      <svg *ngIf="item.kind === 'category'" class="suggest-ic" viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M4 4h6v6H4zm10 0h6v6h-6zM4 14h6v6H4zm10 0h6v6h-6z"/></svg>
      <span class="suggest-text" [innerHTML]="item.html"></span>
      <small class="suggest-meta" *ngIf="item.meta">{{item.meta}}</small>
      <a *ngIf="item.kind === 'recent'" class="suggest-remove" (click)="onRemove(item, $event)">&times;</a>
    </li>
  </ng-container>
  <li class="suggest-empty" *ngIf="!loading && items.length === 0 && hasQuery()">
    {{ 'HEADER.SUGGEST_NO_RESULT' | translate }}
  </li>
  <li class="suggest-footer" *ngIf="showSeeAll && hasQuery()" (click)="seeAll.emit()">
    {{ 'HEADER.SUGGEST_MORE' | translate:{q: query} }}
  </li>
</ul>
